import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCv2LX-mydSidB0HM7xih-B0Y9tHmv984c",
  authDomain: "discountifyreact.firebaseapp.com",
  databaseURL: "https://discountifyreact.firebaseio.com",
  projectId: "discountifyreact",
  storageBucket: "discountifyreact.appspot.com",
  messagingSenderId: "553618244339",
  appId: "1:553618244339:web:fb185ec29c807683"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
